import React from 'react';
import {ResponsiveContainer, BarChart, XAxis, YAxis, Tooltip, Bar, Cell, CartesianGrid } from 'recharts';
import CustomTooltip from '../CustomTooltip'

class GraphAmountCategory extends React.Component {

  render() {
    const {data, t} = this.props
    const translatedData = data && data.map( item => {
      return {name: t(item.name), value: item.value}
    })
    console.log('trans', translatedData);
    return (
        <ResponsiveContainer width="100%" height={350}>
          <BarChart data={translatedData}>
          <CartesianGrid vertical={false}/>
            <XAxis dataKey="name" tickLine={false} />
            <YAxis dataKey="value" allowDecimals={false} tickLine={false} />
            <Bar dataKey="value" fill="blue" barSize={95}>
            {
            this.props.data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % 20]}/>
              ))
            }
            </Bar>
            <Tooltip
              cursor={false}
              content={<CustomTooltip data={this.props.data} />}
              wrapperStyle={styles.wrapper}
              labelStyle={styles.label}
              itemStyle={styles.label}
              />
          </BarChart>
        </ResponsiveContainer>
    )
  }
}

export default GraphAmountCategory;

const colors = ['#541791', '#07B229', '#D8889B', '#002940', '#6C3C11'];

const styles = {

  wrapper: {
    backgroundColor: '#485465',
    border: 'none'
  },

  label: {
    fontSize: '11px'
  },

  container: {
    maxWidth: '500px',
    width: '100%'
  },

  title: {
    fontSize: '16px',
    color: '#485465'
  }

}



// WEBPACK FOOTER //
// ./src/components/GraphAmountCategory/index.jsx